import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import pagedown from 'pagedown';
import { Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faCheckSquare,
  faTimes,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

const converter = pagedown.getSanitizingConverter();

export default class GradedActivity extends Component {
  getHumanAttempts = (answer) => {
    if (!answer.isCorrect) {
      return 'not correct';
    } else if (answer.attempts === 1) {
      return 'correct on the 1st attempt';
    } else if (answer.attempts === 2) {
      return 'correct on the 2nd attempt';
    } else {
      return 'correct after more than two attempts';
    }
  };

  getAnswer = (questionId) => {
    return this.props.responses.find((r) => r.questionId === questionId);
  };

  render() {
    let questions = this.props.questions;
    return (
      <div className="activity-container quiz-results">
        <div className="quiz-results-title box box-min box-row align-items-center p-2">
          <FontAwesomeIcon icon={faCheckSquare} size="2x" className="me-2" />
          <h4>{this.props.name}</h4>
        </div>
        <div className="quiz-questions">
          <Alert variant={this.props.grade.score >= 75 ? 'success' : 'info'}>
            <Alert.Heading>Your score: {this.props.grade.score}%</Alert.Heading>
            {!!this.props.grade.retakesAllowed && (
              <Button
                variant="primary"
                onClick={() =>
                  this.props.retakeExercise(
                    this.props.code,
                    this.props.grade.retakesAllowed
                  )
                }
              >
                Retake
              </Button>
            )}
          </Alert>

          {this.props.showQuizSummary &&
            questions.map((question, index) => {
              let answer = this.getAnswer(question.id);
              if (!answer) {
                return (
                  <div className="answer-response-container" key={question.id}>
                    <p className="muted">
                      Unable to load details for this answer
                    </p>
                  </div>
                );
              }

              let correct = null;

              if (answer.correctAnswerText) {
                correct = (
                  <>
                    <p>
                      Correct Answer:{' '}
                      <strong
                        dangerouslySetInnerHTML={{
                          __html: answer.correctAnswerText,
                        }}
                      />
                    </p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: answer.correctAnswerExplanation,
                      }}
                      style={{
                        fontSize: '90%',
                      }}
                    />
                  </>
                );
              }

              let classes = 'answer-response-container';

              if (answer.isCorrect) {
                classes += ' correct';
              } else {
                classes += ' incorrect';
              }

              return (
                <div className={classes} key={question.id}>
                  <span className="question-num">{index + 1}</span>
                  <div className="box box-row answer-response">
                    <div className="response-icon">
                      <FontAwesomeIcon
                        icon={answer.isCorrect ? faCheck : faTimes}
                        color={answer.isCorrect ? 'green' : 'red'}
                      />
                    </div>
                    <div className="response-description">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: converter.makeHtml(question.description),
                        }}
                      />
                      {correct}
                    </div>
                    <div className="result-scores">
                      <p>
                        Your score for this question{' '}
                        <span
                          className={`badge badge-dark attempts-${answer.attempts}`}
                        >
                          {answer.score}
                        </span>
                      </p>
                      <p>Your answer was {this.getHumanAttempts(answer)}</p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

GradedActivity.propTypes = {
  name: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
  questions: PropTypes.array,
  responses: PropTypes.array,
};

GradedActivity.defaultProps = {
  name: '',
  score: 0,
  questions: [],
  responses: [],
};
